import {useEffect, useRef} from 'react';

import styled from '@emotion/styled';
import {Option} from 'react-multi-select-component';

import {MultiSelect as MultiSelectCore, MultiSelectProps} from '@britishcouncil/react-extro-ui';

const S = {
    MultiSelect: styled(MultiSelectCore)`
        .select-item {
            & > div {
                background: white !important;

                &:hover,
                &:focus,
                &:active {
                    background: linear-gradient(0deg, rgba(151, 218, 255, 0.15), rgba(151, 218, 255, 0.15)),
                    #f7f7f7 !important;

                    span {
                        color: #fff;
                    }
                }

                span {
                    color: black !important;

                    &.checkbox {
                        display: none;
                    }
                }

            }
        }
    `,
};

export const MultiSelect = (props: MultiSelectProps) => {
        const ref = useRef<any>();
        const prevPropsValue = useRef(props.value);

        const focusOption = (option: Option) => {
            const index = props.options.findIndex(o => o.value === option.value);
            if (index !== -1) {
                const dropDownOptions = ref.current.querySelectorAll('.select-panel .select-item');
                const element = dropDownOptions[index];
                if (element)
                    element.focus();
            }
        };

        useEffect(() => {
                const {value: newValues, options, hasSelectAll, disableSearch} = props;
                const {current: prevValues} = prevPropsValue
                prevPropsValue.current = props.value;

                if (hasSelectAll || !disableSearch) return; // No need to proceed further. The issue only occurs if selectAll and search are disabled.

                const isOpen = ref.current.querySelector('.dropdown-content') ?? false;
                if (!isOpen) return; // No need to proceed further.
                if (!ref.current) return; // Reference not available

                //If select all and search are disabled, and the user selected/unselect only the first element, the closing wasn't triggered upon clicking outside it. 
                //Setting focus on element fixes this problem.
                const changedValue = newValues.length < prevValues.length
                    ? prevValues.find(item => !newValues.includes(item))
                    : newValues.find(item => !prevValues.includes(item));

                if (changedValue) focusOption(changedValue);
            }, [props.value, props.hasSelectAll, props.disableSearch, props.options]
        );

        return <div ref={ref}>
            <S.MultiSelect className={props.disabled ? 'disabled' : ''} {...props}/>
        </div>
    }
;
